module.exports = __webpack_public_path__ + "static/media/jiazai02.ec740643.gif";